const initialState =
{
	id: null,
	picture: null,
	browser: null,
	roles: [],
	userId: null,
	canSendMic: false,
	canSendWebcam: false,
	canShareScreen: false,
	canShareFiles: false,
	webcamDevices: null,
	webcamInProgress: false,
	audioInProgress: false,
	screenShareInProgress: false,
	displayNameInProgress: false,
	isSpeaking: false,
	isAutoMuted: true,
	audioInputDevices: null,
	audioOutputDevices: null,
	reaction: null,
	emoji: null
};

const me = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ME_INITIALIZE':
		{
			return initialState;
		}

		case 'SET_ME_USER_ID':
		{
			const {
				userId
			} = action.payload;

			return {
				...state,
				userId: userId
			};
		}

		case 'SET_ME':
		{
			const {
				peerId
			} = action.payload;

			return {
				...state,
				id: peerId
			};
		}

		case 'SET_ME_REACTION':
		{
			const { reaction } = action.payload;

			return { ...state, reaction };
		}

		case 'SET_ME_EMOJI':
		{
			const { emoji } = action.payload;

			return { ...state, emoji };
		}

		case 'SET_BROWSER':
		{
			const { browser } = action.payload;

			return { ...state, browser };
		}

		case 'ADD_ROLE':
		{
			const roles = [ ...state.roles, action.payload.roleId ];

			return { ...state, roles };
		}

		case 'REMOVE_ROLE':
		{
			const roles = state.roles.filter((roleId) =>
				roleId !== action.payload.roleId);

			return { ...state, roles };
		}

		case 'CLEAR_ROLE':
		{
			return { ...state, roles: [] };
		}

		case 'SET_PICTURE':
			return { ...state, picture: action.payload.picture };

		case 'SET_MEDIA_CAPABILITIES':
		{
			const {
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			} = action.payload;

			return {
				...state,
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			};
		}

		case 'SET_AUDIO_INPUT_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioInputDevices: devices };
		}

		case 'SET_AUDIO_OUTPUT_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioOutputDevices: devices };
		}

		case 'SET_WEBCAM_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, webcamDevices: devices };
		}

		case 'SET_AUDIO_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, audioInProgress: flag };
		}

		case 'SET_WEBCAM_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, webcamInProgress: flag };
		}

		case 'SET_SCREEN_SHARE_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, screenShareInProgress: flag };
		}

		case 'SET_DISPLAY_NAME_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, displayNameInProgress: flag };
		}

		case 'SET_IS_SPEAKING':
		{
			const { flag } = action.payload;

			return { ...state, isSpeaking: flag };
		}

		case 'SET_AUTO_MUTED':
		{
			const { flag } = action.payload;

			return { ...state, isAutoMuted: flag };
		}

		default:
			return state;
	}
};

export default me;
